import React from 'react';
import { useTranslation } from 'react-i18next';
import faqData from './faqData';

const FAQ = () => {
  const { t } = useTranslation();

  // Split the FAQ data into two equal parts for two columns
  const midpoint = Math.ceil(faqData.length / 2);
  const leftColumnFAQs = faqData.slice(0, midpoint);
  const rightColumnFAQs = faqData.slice(midpoint);

  return (
    <>
      <section id="faq" className="py-2">
        <div className="container">
          <h1 className="center p-1">{t('Frequently Asked Questions')}</h1>
          <div className="bottom-line"></div>

          <div className="row py-2">
            <div className="col-lg-12">
              <div id="bootstrap-accordion_medicalform" className="panel-group accordionStyles accordion" role="tablist" aria-multiselectable="true">
                <div className="row">
                  <div className="col-lg-6">
                    {leftColumnFAQs.map((faq, index) => (
                      <div className="card" key={faq.id}>
                        <div className="card-header" role="tab" id={`heading${faq.id}`}>
                          <a
                            role="button"
                            className="panel-title collapsed pr-5 text-black"
                            data-toggle="collapse"
                            data-core=""
                            href={`#collapse${faq.id}`}
                            aria-expanded="false"
                            aria-controls="collapse1"
                          >
                            <h4 className="mbr-fonts-style display-7">
                              {`${index + 1}. ${t(faq.question)}`}
                              <div>
                                <span className="toggle-icon inactive sign mbr-iconfont"></span>
                              </div>
                            </h4>
                          </a>
                        </div>
                        <div id={`collapse${faq.id}`} className="panel-collapse noScroll collapse " role="tabpanel" aria-labelledby={`heading${faq.id}`} data-parent="#bootstrap-accordion_medicalform">
                          <div className="panel-body">
                            <p className="mbr-fonts-style panel-text display-4" dangerouslySetInnerHTML={{ __html: t(faq.answer) }}></p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="col-lg-6">
                    {rightColumnFAQs.map((faq, index) => (
                      <div className="card" key={faq.id}>
                        <div className="card-header" role="tab" id={`heading${faq.id}`}>
                          <a
                            role="button"
                            className="panel-title collapsed pr-5 text-black"
                            data-toggle="collapse"
                            data-core=""
                            href={`#collapse${faq.id}`}
                            aria-expanded="false"
                            aria-controls="collapse1"
                          >
                            <h4 className="mbr-fonts-style display-7">
                              {`${index + leftColumnFAQs.length + 1}. ${t(faq.question)}`}
                              <div>
                                <span className="toggle-icon inactive sign mbr-iconfont"></span>
                              </div>
                            </h4>
                          </a>
                        </div>
                        <div id={`collapse${faq.id}`} className="panel-collapse noScroll collapse " role="tabpanel" aria-labelledby={`heading${faq.id}`} data-parent="#bootstrap-accordion_medicalform">
                          <div className="panel-body">
                            <p className="mbr-fonts-style panel-text display-4" dangerouslySetInnerHTML={{ __html: t(faq.answer) }}></p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
